export class TabAclrrModel {
  codAclrr:	string
  desAdc:	string
  idAclrr:	number
  idArea:	number
}